import React from 'react'
import {
  CBadge,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CListGroup,
  CListGroupItem,
  CRow,
} from '@coreui/react-pro'
import { CChartDoughnut } from '@coreui/react-chartjs'
import { useNavigate } from 'react-router-dom'
import { STATUS_BADGE_COLOR, STATUS_LABEL } from './stepStatus'

const DOUGHNUT_COLORS = {
  completed: '#2eb85c',
  in_progress: '#f9b115',
  pending: '#9da5b1',
}

const SetupProgressCard = ({ steps, counts, percentComplete, totalSteps }) => {
  const navigate = useNavigate()

  const chartData = {
    labels: ['Completed', 'In Progress', 'Pending'],
    datasets: [
      {
        data: [counts.completed, counts.in_progress, counts.pending],
        backgroundColor: [
          DOUGHNUT_COLORS.completed,
          DOUGHNUT_COLORS.in_progress,
          DOUGHNUT_COLORS.pending,
        ],
        hoverBackgroundColor: [
          DOUGHNUT_COLORS.completed,
          DOUGHNUT_COLORS.in_progress,
          DOUGHNUT_COLORS.pending,
        ],
      },
    ],
  }

  const chartOptions = {
    cutout: '72%',
    plugins: {
      legend: { display: false },
    },
  }

  return (
    <CCard className="mb-4">
      <CCardHeader>Setup Progress</CCardHeader>
      <CCardBody>
        <CRow className="align-items-center">
          <CCol md={5}>
            <CRow className="align-items-center">
              <CCol xs={6}>
                <div style={{ position: 'relative' }}>
                  <CChartDoughnut data={chartData} options={chartOptions} />
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      textAlign: 'center',
                    }}
                  >
                    <div style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{percentComplete}%</div>
                    <div className="text-medium-emphasis" style={{ fontSize: '0.75rem' }}>
                      Complete
                    </div>
                  </div>
                </div>
              </CCol>
              <CCol xs={6}>
                <div className="mb-2">
                  <strong>{totalSteps}</strong> Essential Steps
                </div>
                <div className="mb-1">
                  <CBadge color="success" shape="rounded-pill">
                    &nbsp;
                  </CBadge>{' '}
                  {counts.completed} Completed
                </div>
                <div className="mb-1">
                  <CBadge color="warning" shape="rounded-pill">
                    &nbsp;
                  </CBadge>{' '}
                  {counts.in_progress} In Progress
                </div>
                <div>
                  <CBadge color="secondary" shape="rounded-pill">
                    &nbsp;
                  </CBadge>{' '}
                  {counts.pending} Pending
                </div>
              </CCol>
            </CRow>
          </CCol>
          <CCol md={7}>
            <div className="fw-bold mb-2">Your Game Setup Journey</div>
            <CListGroup>
              {steps.map((step) => (
                <CListGroupItem
                  key={step.key}
                  className="d-flex justify-content-between align-items-center"
                  style={{ cursor: step.route ? 'pointer' : 'default' }}
                  onClick={step.route ? () => navigate(step.route) : undefined}
                >
                  <span>
                    {step.order}. {step.label}
                  </span>
                  <CBadge color={STATUS_BADGE_COLOR[step.status]} shape="rounded-pill">
                    {STATUS_LABEL[step.status]}
                  </CBadge>
                </CListGroupItem>
              ))}
            </CListGroup>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  )
}

export default SetupProgressCard
